
import * as React from "react";
import { IOffer } from "../../../interfaces/IOffer";
import { Api } from "../../../lib/Api";
import { CalcSobransCredit } from "./CalcSobransCredit";
import InputTime from "../../global/InputTime";
import LoaderComp from "../../../../avernus/loader/source/LoaderComp";

interface IModifyOfferDialogProps {
    id                    : number
    restaurantId          : number
    closed                : Function
    modifyJustPortionMode?: boolean
}

interface IGetXHR{
    form: IOffer
}

interface IModifyOfferDialogState {
    success                  : string
    error                    : string
    form                     : IOffer
    loading                  : boolean
    availablePortionsModifier: number
    price                    : number
    priceFieldName           : 'discountedPrice'|'originalPrice'
    currency                 : string
    offerType                : any
}

interface ISaveData{
    id                       : number
    restaurantId             : number
    price                    : number
    priceFieldName           : 'discountedPrice'|'originalPrice'


}

export default class ModifyOfferDialog extends React.Component<IModifyOfferDialogProps, IModifyOfferDialogState>{

  	constructor(props:IModifyOfferDialogProps){
        super(props);
        this.state = {
            success                  : null,
            error                    : null,
            form                     : this.props.id === 0?this.createEmptyForm(): null,
            loading                  : false,
            availablePortionsModifier: 0,
            priceFieldName           : 'originalPrice',
            price                    : 0,
            currency                 : '$',
            offerType                : []
        }
        this.init();
    }

    init() {
        Api.call('/restaurants/offers/get', {
                id          : this.props.id,
                restaurantId: this.props.restaurantId
            }, (result:IGetXHR) =>{
            let form                 = result.form;
            if ( form === null ) {
                this.setState({
                    loading                : false
                });
            }else{
                let currency = form.discountedPrice>0?form.discountedPriceCurrency: form.originalPriceCurrency;
                this.setState({
                    form                     : form,
                    loading                  : false,
                    availablePortionsModifier: form.availablePortions,
                    priceFieldName           : form.discountedPrice>0?'discountedPrice'   : 'originalPrice',
                    price                    : form.discountedPrice>0?form.discountedPrice: form.originalPrice,
                    currency                 : currency==='USD'?'$':currency,
                    offerType                : form.offerType
                });
            }
        } );
    }

    createEmptyForm(): IOffer {
        return {
            id                      : 0,
            name                    : '',
            description             : '',
            created_at              : '',
            updated_at              : '',
            offerTypeId             : 0,
            offerTodayEnabled       : false,
            offerTodayStart         : '',
            offerTodayEnd           : '',
            offerTimingEnabled      : false,
            offerHoursMondayStart   : '',
            offerHoursMondayEnd     : '',
            offerHoursTuesdayStart  : '',
            offerHoursTuesdayEnd    : '',
            offerHoursWednesdayStart: '',
            offerHoursWednesdayEnd  : '',
            offerHoursThursdayStart : '',
            offerHoursThursdayEnd   : '',
            offerHoursFridayStart   : '',
            offerHoursFridayEnd     : '',
            offerHoursSaturdayStart : '',
            offerHoursSaturdayEnd   : '',
            offerHoursSundayStart   : '',
            offerHoursSundayEnd     : '',
            originalPrice           : 0,
            originalPriceCurrency   : 'USD',
            discountedPrice         : 0,
            discountedPriceCurrency : 'USD',
            availablePortions       : 1,
            availablePortionsUnit   : 'portions',
            deliveryArray           : [],
            restaurantId            : this.props.restaurantId,
            sobrasCredit            : 0,
            co2                     : 0,
            offerType               : []
       };
    }

    // private closeClickHandler(evt): void {
    //     evt.preventDefault();
    //     this.props.closed();
    // }

    private submitHandler(evt): void {
        evt.preventDefault();
        this.save();
    }

    private activateToggleBtnClickHandler(evt): void {
        evt.preventDefault();
        this.save(true);
    }

     private changeInputHandler(evt, type:string, forceValue?:any): void {
        if ( evt !== undefined ) {
            evt.preventDefault();
        }
        var form = this.state.form;
        if ( forceValue === undefined ) {
            form[type] = evt.target.value;
        }else{
            form[type] = forceValue;
        }
        this.setState({
             form: form
        });
    }


    private recalcSobranCreditAndCo2(availablePortions){
        var form            = this.state.form;

        let calced = CalcSobransCredit.calc(availablePortions)
        form.sobrasCredit   = calced.sobrasCredit;
        form.co2            = calced.co2;
        this.setState({
             form: form
        });
    }

    private save(offerTodayEnabled:boolean=false){
        this.setState({
             loading: true
        }, () =>{
            let saveData:ISaveData = {
                id                       : this.props.id,
                restaurantId             : this.state.form.restaurantId,
                priceFieldName           : this.state.priceFieldName,
                price                    : this.state.price,
            };

            Api.call('/restaurant/offers/modifyWithModal', saveData, (result)=>{
                this.setState({
                    success:    result.success,
                    error:      result.error,
                    loading:    false
                }, () =>{
                    setTimeout(() => {
                        this.props.closed();
                    }, 800);
                });
            });
        });
    }

    private changeAvailablePortionsModifierHandler(evt): void {
        evt.preventDefault();
        this.setState({
            availablePortionsModifier: parseFloat(evt.target.value)
        }, ()=>{
            this.recalcSobranCreditAndCo2(this.state.form.availablePortions);
        });
    }

    private increaseAvailablePortionsModifier(evt, increase:boolean):void{
        evt.preventDefault();
        let availablePortionsModifier = this.state.availablePortionsModifier;
        if ( increase === true  ) {
            ++ availablePortionsModifier;
        }else{
            -- availablePortionsModifier;
        }
        if ( availablePortionsModifier < 0 ) {
            availablePortionsModifier = 0;
        }
        this.setState({
            availablePortionsModifier: availablePortionsModifier
        }, ()=>{
            this.recalcSobranCreditAndCo2(this.state.form.availablePortions);
        });
    }

    private changePriceHandler(evt): void {
        evt.preventDefault();
        this.setState({
            price: parseFloat(evt.target.value)
        });
    }

    private increasePriceModifier(evt, increase:boolean):void{
        evt.preventDefault();
        let price = this.state.price;
        if ( increase === true  ) {
            ++ price;
        }else{
            -- price;
        }
        if ( price < 0 ) {
            price = 0;
        }
        this.setState({
            price: price
        });
    }


    render() {
        let form                            = this.state.form;
        console.log(form);
        let modifyJustPortionMode:boolean   = this.props.modifyJustPortionMode !== undefined && this.props.modifyJustPortionMode === true;
        return (
            <div className="modal_content edit-offer-box">
            { (this.state.loading === true || this.state.form === null)?<div>
                    <LoaderComp show={true} />
                </div>:<>
                    <form onSubmit={ e => this.submitHandler(e) }>
                        <div className="form-row">
                            <div className="col text-center">
                                <img src = {this.state.offerType.img}/>
                                <h1>
                                    { this.state.offerType.name}
                                </h1>
                            </div>
                        </div>

                        { modifyJustPortionMode === false?<>
                            <div className="form-row label_row">
                                <div className="col text-center">
                                    price:
                                </div>
                            </div>
                            <div className="form-row modifier_row">
                                <div className="col text-right">
                                    <a className="btn price_minus_btn" onClick={ (e) => { this.increasePriceModifier(e, false); } }>
                                        -
                                    </a>
                                </div>
                                <div className="col-5 price-field">
                                    {this.state.price}{ this.state.currency }
                                </div>
                                <div className="col text-left">
                                    <a className="btn price_plus_btn" onClick={ (e) => { this.increasePriceModifier(e, true); } }>
                                        +
                                    </a>
                                </div>
                            </div>
                        </>:<>
                        </> }

                        <div className="col-sm-12">
                            { this.state.error !== null?<div className="alert alert-danger">
                                    { this.state.error }
                            </div>:''}
                            { this.state.success !== null?<div className="alert alert-success">
                                    { this.state.success }
                            </div>:''
                            }
                        </div>

                        { this.props.modifyJustPortionMode === true?<>
                            <div className="form-row">
                                <div className="offset-1 col-10">
                                    <button className="dark_btn btn-block" id="modify_offer_dialog_save_btn" type="submit">SAVE</button>
                                </div>
                            </div>
                        </>:<>
                            <div className="form-row">
                                <div className="offset-1 col-10">
                                    <button className="purple_btn" id="modify_offer_dialog_save_btn" type="submit">Modify offer</button>
                                </div>
                            </div>

                            { !this.state.form.isActiveToday &&
                                <div className="form-row">
                                    <div className="offset-1 col-10">
                                        <button className="green_btn" id="activate_toggle_offer_dialog_save_btn" type="button" onClick={ e => this.activateToggleBtnClickHandler(e) }>
                                            Active offer
                                        </button>
                                    </div>
                                </div>
                            }
                        </> }


                    </form>
                </>
            }
            </div>
        );
    }
}
